import axios from 'axios';
import {errors as E} from 'common/constants/errors';

const defaultRequestValues = {
  cityID: -1,
  streetID: -1,
  gush: '',
  helka: '',
  fromDate: '',
  toDate:'',
};

export const getStep9GridForExcel = ({
                               actions: {
                                 pending,
                                 success,
                                 failure
                               },
                               api,
                               defaultValues = defaultRequestValues
                             }) => values => dispatch => {
  dispatch({
    type: pending
  });

  const data = {
    ...defaultValues,
    ...values,
  };

  return axios.post(api, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      const {gridData} = body;
      dispatch({
        type: success,
        payload: {listForExcel: gridData},
      });
      return gridData ?? []
    })
    .catch((err) => {
      dispatch({
        type: failure,
        payload: err.message
      });
    });
};
